import { Meeting } from "@/schema"
import { ReadonlyAttribute } from "@ui/forms/inline"
import { BookOpen, CalendarDays } from "lucide-react"

import { UserAvatar } from "@/components/users/user-avatar"

interface MeetingBookInfoProps {
  meeting: Meeting
  users?: { id: string; full_name: string }[]
}

export function MeetingBookInfo({ meeting, users }: MeetingBookInfoProps) {
  return (
    <>
      {meeting.book_name && <ReadonlyAttribute label="Book" LabelIcon={BookOpen} hideLabel value={meeting.book_name} />}
      {meeting.user_ids && meeting.user_ids.length > 0 && (
        <ReadonlyAttribute
          label="Calendar"
          LabelIcon={CalendarDays}
          hideLabel
          renderValue={() => (
            <div className="flex items-center gap-1">
              {meeting.user_ids?.map((userId) => {
                const user = users?.find((u) => u.id === userId)
                return (
                  <div key={userId} className="flex items-center gap-1">
                    <UserAvatar userId={userId} size="xs" />
                    <span className="text-sm">{user?.full_name || "Unknown"}&apos;s calendar</span>
                  </div>
                )
              })}
            </div>
          )}
        />
      )}
    </>
  )
}
